module.exports = __webpack_public_path__ + "img/img-left-top.7b69015f.png";